import { fetchQuery_DEPRECATED as fetchQuery } from 'react-relay/legacy';
import { Environment } from 'relay-runtime';
import { hasValidUserSessionGeoInfo, setUserSessionGeoInfo } from './regionalInfoHelpers';
import { userGeoInfoQuery } from './userGeoInfoQuery';
import { userGeoInfoQuery as GeoInfoQueryType } from './__generated__/userGeoInfoQuery.graphql';

type SetRegionalInfoArgs = {
    relayEnv: Environment;
    cookieDomain: string;
    hasRegionsCookieValue: boolean;
    userId: string;
};
const forceSetUserRegionalInfo = async ({
    relayEnv,
    cookieDomain,
    hasRegionsCookieValue,
    userId,
}: SetRegionalInfoArgs): Promise<void> => {
    const data = await fetchQuery<GeoInfoQueryType>(relayEnv, userGeoInfoQuery, {
        cookieDomain: !hasRegionsCookieValue ? cookieDomain : '',
        userId,
    });

    const userGeoInfo = data?.viewer?.regionalInfo?.[0];
    setUserSessionGeoInfo(userGeoInfo);
};

const setUserRegionalInfo = ({
    relayEnv,
    cookieDomain,
    hasRegionsCookieValue,
    userId,
}: SetRegionalInfoArgs): void => {
    if (!hasValidUserSessionGeoInfo() || !hasRegionsCookieValue) {
        forceSetUserRegionalInfo({ relayEnv, cookieDomain, hasRegionsCookieValue, userId });
    }
};

export { setUserRegionalInfo, forceSetUserRegionalInfo };
